import { MARKET_NEWS_DATA, MARKET_NEWS_SET_ERROR, MARKET_NEWS_HIDE_ERROR, MARKET_NEWS_START_LOADER, MARKET_NEWS_STOP_LOADER, } from "./../../interfaces/Home/iMarketNews";
const initialState = {
    data: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const marketNews = (state = initialState, action) => {
    switch (action.type) {
        case MARKET_NEWS_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case MARKET_NEWS_SET_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MARKET_NEWS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case MARKET_NEWS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case MARKET_NEWS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default marketNews;
